import React from "react";

import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../App/Analytics";

import { GetPostV2 } from "../../graphql/customWebappQueries/expandedPostQueries";
import {
  ExpandedPostHeader,
  ExpandedPostHeaderConfig,
} from "./ExpandedPostHeader";
import { Get_Post_V2Query, Get_Post_V2QueryVariables } from "../../API";
import {
  LoadingView,
  ErrorView,
  CenteringView,
} from "../../Components/RecurringSmallViews/RecurringSmallViews";

import {
  makeNonRecursivePostCardConfig,
  makeFootnoteConfig,
} from "../../Infrastucture/ComponentConfigBackendBridge";

import {
  ExpandedPostTabSwitcher,
  ExpandedPostTabSwitcherConfig,
} from "./ExpandedPostTabSwitcher";

import { useUrlParams } from "../../Infrastucture/MissingReactRouter";

function _ExpandedPostLoading(): JSX.Element {
  const { userHandle, postId } = useParams();

  logEvent(analytics, "screen_view", {
    firebase_screen: "ExpandedPostLoading",
    firebase_screen_class: "ExpandedPostLoading",
    user_handle: userHandle,
    post_id: postId,
  });

  const _primaryPostPreExpandedAndAutoplaying = useUrlParams().get(
    "primaryPostPreExpandedAndAutoplaying"
  );
  const primaryPostPreExpandedAndAutoplaying =
    _primaryPostPreExpandedAndAutoplaying === "true";

  if (!postId || !userHandle) {
    return ErrorView();
  }

  const { loading, error, data } = useQuery<
    Get_Post_V2Query,
    Get_Post_V2QueryVariables
  >(GetPostV2, {
    errorPolicy: "ignore",
    variables: {
      postId,
    },
  });

  if (loading) {
    return LoadingView();
  }
  if (error) {
    return ErrorView();
  }

  const fetchedPost = data?.getPost;
  if (fetchedPost) {
    const expandedPostHeaderConfig: ExpandedPostHeaderConfig = {
      primaryPost: makeNonRecursivePostCardConfig(
        fetchedPost,
        primaryPostPreExpandedAndAutoplaying
      ),
      primaryPostFootnote: makeFootnoteConfig(fetchedPost),
    };

    const tabSwitcherConfig: ExpandedPostTabSwitcherConfig = {
      postId: fetchedPost.id,
    };

    return (
      <div>
        <ExpandedPostHeader {...expandedPostHeaderConfig} />

        <ExpandedPostTabSwitcher {...tabSwitcherConfig} />
      </div>
    );
  }

  return ErrorView("Unexpected.");
}

function ExpandedPostLoading(): JSX.Element {
  return CenteringView(_ExpandedPostLoading());
}

export default ExpandedPostLoading;
